import Image from "next/image";
import dynamic from "next/dynamic";
import Link from "next/link";
import React, { useState, useEffect, useRef } from "react";

const SeeAll = dynamic(() => import("components/links/SeeAll"));
// const SideScrollButtons = dynamic(() =>
//   import("components/ui/buttons/SideScrollButtons/SideScrollButtons")
// );
import SideScrollButtons from "components/ui/buttons/SideScrollButtons/SideScrollButtons";

import styles from "./AccordionItem.module.scss";

const AccordionItem = ({
  title,
  titleLink,
  seeAllLink,
  icon,
  seeAll = false,
  startOpen = false,
  isOpen,
  children,
  isPageSection = false,
  titleFontSize,
  id,
  style,
  scrollButtons = false,
  scrollElementRef,
  classNames,
  instantClose,
  onClose,
  onToggle,
}) => {
  const [firstRenderComplete, setFirstRenderComplete] = useState(false);
  const [opened, setOpened] = useState(startOpen);

  // useEffect(() => {
  //   if (!firstRenderComplete) {
  //     setFirstRenderComplete(true);
  //     return;
  //   }

  //   setOpened(isOpen);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isOpen]);

  // useEffect(() => {
  //   if (!opened && !isOpen && onClose) {
  //     onClose(id);
  //   }
  // }, [opened, id, isOpen, onClose]);

  const innerItemRef = useRef();

  const iconWidth = isPageSection ? "30" : "20";

  /* Styles need to be set inline to avoid className collisions when there's an accordion within an accordion */
  const iconOpenStyles = {
    transform: "rotate(180deg)",
  };

  const innerOpenStyles = {
    maxHeight: "100%",
    transitionTimingFunction: "cubic-bezier(0.895, 0.03, 0.685, 0.22)",
    transitionDuration: "0.5s",
    transitionProperty: "max-height",
  };

  const contentOpenStyles = {
    opacity: "1",
    transform: "translateY(0)",
    transitionDelay: "0s",
    transitionTimingFunction: "ease-in-out",
    transitionDuration: "0.5s",
    transitionProperty: "opacity, transform",
  };

  return (
    <div
      className={`${styles.accordionItem} ${
        classNames ? classNames.join(" ") : ""
      } ${opened ? styles.opened : ""}`}
      id={id}
      style={style ?? {}}
    >
      <div
        className={`${styles.accordionItemLine}`}
        onClick={() => setOpened(!opened)}
        // onClick={() => {
        //   if (onToggle) {
        //     onToggle(id);
        //   } else {
        //     setOpened(!opened);
        //   }
        // }}
      >
        <div
          className={`${styles.accordionItemTitle} ${seeAll && styles.seeAll}`}
        >
          {icon && (
            <div
              className={`${styles.iconContainer}`}
              style={{
                width: `${iconWidth}px`,
              }}
            >
              {typeof icon === "string" && (
                <Image
                  src={
                    icon && typeof icon === "string"
                      ? icon
                      : "public/assets/img/icons/plus-sign.svg"
                  }
                  alt="Overview icon"
                  width={iconWidth}
                  height={iconWidth}
                />
              )}
              {typeof icon !== "string" && icon}
            </div>
          )}
          {isPageSection && (
            <h2
              className={`${styles.accordionItemTitleText} `}
              style={{ fontSize: titleFontSize }}
              onClick={(event) => (titleLink ? event.stopPropagation() : "")}
            >
              {titleLink && <Link href={titleLink}>{title}</Link>}
              {!titleLink && title}
            </h2>
          )}
          {!isPageSection && (
            <div
              className={`${styles.accordionItemTitleText}`}
              style={{ fontSize: titleFontSize ?? "" }}
            >
              {title}
            </div>
          )}
        </div>
        <span className={`${styles.endContent}`}>
          {scrollButtons === true && (
            <SideScrollButtons cardRowRef={scrollElementRef} />
          )}
          {seeAll && (titleLink || seeAllLink) && (
            <Link href={titleLink || seeAllLink} className={`${styles.seeAll}`}>
              <SeeAll />
            </Link>
          )}
          <span
            className={`${styles.accordionItemIcon}`}
            style={opened ? { ...iconOpenStyles } : {}}
          />
        </span>
      </div>
      <div
        className={`${styles.accordionItemInner}`}
        ref={innerItemRef}
        style={
          opened
            ? { ...innerOpenStyles }
            : !opened && instantClose
            ? { transitionDuration: "0s" }
            : {}
        }
      >
        <div
          className={`${styles.accordionItemContent}`}
          style={opened ? { ...contentOpenStyles } : {}}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
